import React, { ReactNode, useContext } from "react";
import { VestigingFormContext } from "../../views/Vestigingen/VestigingForm";
import { useFormContext, useWatch } from "react-hook-form";
import { FormNameContext } from "./FormGroupWithInlineButtonsTC";
import { InlineFormButton } from "./InlineFormButton";

export function ContextualValue({ targetValue, children }: { targetValue: any; children: ReactNode }) {
  const { setValue }: VestigingFormContext = useFormContext();
  const name = useContext(FormNameContext);
  const v = useWatch({ name });

  return (
    <InlineFormButton
      disabled={String(v) === String(targetValue)}
      onClick={() => {
        setValue(name, targetValue, { shouldDirty: true, shouldValidate: true });
      }}
    >
      {children}
    </InlineFormButton>
  );
}
